import {
  RATE_MASTER_FETCH_DATA,
  RATE_MASTER_ENABLE_LOADING,
  RATE_MASTER_FETCH_ERROR,
  RATE_MASTER_DISABLE_LOADING,
  RATE_MASTER_SET_FILTERS,
  RATE_MASTER_SET_PAGINATION,
  RATE_MASTER_RESET_FILTERS,
  RATE_MASTER_RESET_PAGINATION,
  RATE_MASTER_SET_PREV_PAGINATION,
  RATE_MASTER_GET_MASTER,
} from 'src/actions/constants';
import { fetchDataPagination } from './CommonReducerFunctions';

const defaultState = {
  isLoading: false,
  ratesData: [],
  ratesMasterData: [],
  selectedFilters: {
    mode: 'FCL',
    polList: [],
    podList: [],
    carrierList: [],
    containersList: [],
    descendingOrder: true,
    isDirectShipment: false,
    includeExpiredRates: false,
    lastRowId: '',
    chargeCategory: 'FREIGHT',
    cargoList: undefined,
    cargoType: undefined,
    cargoSubTypeList: undefined,
    totalPriceFilter: undefined,
    movementTypeList: undefined,
    incotermList: undefined,
    stuffingLocationIdList: undefined,
    destuffingLocationIdList: undefined,
    ratingList: undefined,
    sourceList: undefined,
    grossWeightFilter: undefined,
    totalVolumeFilter: undefined,
    originCity: undefined,
    originState: undefined,
    destinationCity: undefined,
    destinationState: undefined,
  },
  pagination: {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
    lastSortedColumnValueNext : 0,
    lastSortedColumnValuePrev: 0,
    lastRowIdNext: 0,
    lastRowIdPrev: 0,
  },
  prevPagination : {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
    lastSortedColumnValueNext : 0,
    lastSortedColumnValuePrev: 0,
    lastRowIdNext: 0,
    lastRowIdPrev: 0,
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {

    case RATE_MASTER_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case RATE_MASTER_SET_FILTERS : {
      return {
        ...state,
        selectedFilters :{
          ...state.selectedFilters,
          ...action.data,
        },
      };
    }

    case RATE_MASTER_SET_PAGINATION : {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case RATE_MASTER_DISABLE_LOADING : {
      return {
        ...state,
        isLoading : false,
      };
    }

    case RATE_MASTER_RESET_FILTERS: {
      return {
        ...state,
        selectedFilters: defaultState.selectedFilters,
      };
    }

    case RATE_MASTER_RESET_PAGINATION: {
      return {
        ...state,
        pagination: {
          currentPageNumber : 1,
          nextOrPrev: 'first',
          resultPerPage: state.pagination.resultPerPage,
        },
      };
    }
    case RATE_MASTER_SET_PREV_PAGINATION: {
      return {
        ...state,
        pagination: state.prevPagination,
      };
    }

    case RATE_MASTER_FETCH_DATA : {
      return {
        ...state,
        ratesData : action.data ? action.data.data : [],
        prevPagination : {
          ...state.pagination,
        },
        pagination : {
          ...state.pagination,
          ...fetchDataPagination(action, state),
        },
      };
    }

    case RATE_MASTER_GET_MASTER : {
      return {
        ...state,
        ratesMasterData : action.data ? action.data : [],
      };
    }

    case RATE_MASTER_FETCH_ERROR : {
      return {
        ...state,
        errorMessage : action.data,
        ratesData : [],
      };
    }

    default: return state;

  }
};
